import snakecaseKeys from 'snakecase-keys';
import { CosmwasmWasmV1Tx } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
/**
 * @category Messages
 */
export default class MsgUpdateAdmin extends MsgBase {
    static fromJSON(params) {
        return new MsgUpdateAdmin(params);
    }
    toProto() {
        const { params } = this;
        const message = CosmwasmWasmV1Tx.MsgUpdateAdmin.create();
        message.sender = params.sender;
        message.newAdmin = params.newAdmin;
        message.contract = params.contract;
        return CosmwasmWasmV1Tx.MsgUpdateAdmin.fromPartial(message);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/cosmwasm.wasm.v1.MsgUpdateAdmin',
            ...proto,
        };
    }
    toAmino() {
        const proto = this.toProto();
        const message = {
            ...snakecaseKeys(proto),
        };
        return {
            type: 'wasm/MsgUpdateAdmin',
            value: { ...message },
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/cosmwasm.wasm.v1.MsgUpdateAdmin',
            ...value,
        };
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/cosmwasm.wasm.v1.MsgUpdateAdmin',
            message: proto,
        };
    }
    toBinary() {
        return CosmwasmWasmV1Tx.MsgUpdateAdmin.encode(this.toProto()).finish();
    }
}
